import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { router } from "./router";
import { RouterProvider } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./store";
import { ThemeProvider } from "@mui/material/styles";
import { ThemeProvider as StyledThemeProvider } from "styled-components";
import theme from "./theme";
import * as Sentry from "@sentry/react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { HelmetProvider } from "react-helmet-async";
import * as serviceWorkerRegistration from "./firebase/serviceWorkerRegistration";
//global fonts
import "@fontsource/roboto";
import "@fontsource/open-sans";
import "@fontsource/poppins";

Sentry.init({
	dsn: process.env.REACT_APP_SENTRY_DSN,
	integrations: [Sentry.browserTracingIntegration()],
	environment: process.env.REACT_APP_ENV || "development",

	// Set tracesSampleRate to 1.0 to capture 100%
	// of transactions for performance monitoring.
	// We recommend adjusting this value in production
	tracesSampleRate: 1.0,
	// Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
	beforeSend: event => {
		if (window.location.hostname === "localhost") {
			return null;
		}

		const ignoreMessages = ["Java object is gone", "enableDidUserTypeOnKeyboardLogging", "Error invoking postMessage"];

		if (event.exception?.values?.some(val => ignoreMessages.some(msg => val.value?.includes(msg)))) {
			return null;
		}

		return event;
	},
	denyUrls: [
		/facebook\.com/i,
		/connect\.facebook\.net/i,
		/google-analytics\.com/i,
		/googletagmanager\.com/i,
		/gstatic\.com/i,
		/doubleclick\.net/i,
		/analytics\.google\.com/i,
		/maps\.googleapis\.com/i,
		/chrome-extension:\/\//i
	]
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
	// <React.StrictMode>
	<HelmetProvider>
		<Provider store={store}>
			<ThemeProvider theme={theme}>
				<StyledThemeProvider theme={theme}>
					<LocalizationProvider dateAdapter={AdapterDateFns}>
						<GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID as string}>
							<RouterProvider router={router} />
						</GoogleOAuthProvider>
					</LocalizationProvider>
				</StyledThemeProvider>
			</ThemeProvider>
		</Provider>
	</HelmetProvider>
	// </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// firebase registerServiceWorker
serviceWorkerRegistration.registerServiceWorker();
